<template>
  <AisSortBy :items="productStore.sortingOptions">
    <template #default="{ items, refine, currentRefinement }">
      <SortSelect
        :items="items"
        :current-refinement="currentRefinement"
        @on-selection-changed="refine"
      />
    </template>
  </AisSortBy>
</template>

<script setup lang="ts">
import SortSelect from '@/pages/CategoryPage/Partials/SortSelect.vue';
import { useAlgoliaProductStore } from '@/stores/Category/AlgoliaProductStore';

const productStore = useAlgoliaProductStore();
</script>
